<div class="flex h-full min-h-0 flex-col gap-4">
  <!-- Day range selector -->
  <div class="flex shrink-0 flex-wrap items-center gap-2">
    <span class="text-sm font-medium text-gray-500">Show last:</span>
    @for (option of dayOptions; track option) {
    <button
      type="button"
      (click)="onDaysChange(option)"
      [class]="
        selectedDays() === option
          ? 'px-3 py-1.5 rounded-md text-xs font-medium bg-orange-500 text-white'
          : 'px-3 py-1.5 rounded-md text-xs font-medium bg-gray-100 text-gray-600 hover:bg-gray-200'
      "
    >
      {{ option }} days
    </button>
    }
  </div>

  <div
    class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-300 bg-white"
  >
    <div class="min-h-0 flex-1 overflow-y-auto">
      <table
        class="min-w-[980px] border-separate border-spacing-0 text-sm text-gray-700 sm:min-w-full"
      >
        <thead class="font-semibold">
          <tr>
            <th
              scope="col"
              class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
            >
              Date &amp; Time
            </th>
            <th
              scope="col"
              class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
            >
              Scheduled
            </th>
            <th
              scope="col"
              class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
            >
              Status
            </th>
            <th
              scope="col"
              class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
            >
              Sessions Closed
            </th>
            <th
              scope="col"
              class="sticky top-0 z-10 bg-slate-600 p-3 text-left text-slate-100"
            >
              Error
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-200">
          @if (isLoading()) {
          <tr class="bg-white">
            <td colspan="5" class="p-6 text-center text-sm text-gray-500">
              Loading auto-close logs...
            </td>
          </tr>
          } @else { @for (log of logs(); track log.id; let i = $index) {
          <tr
            class="text-sm transition-colors duration-150 hover:bg-orange-50"
            [class.bg-white]="i % 2 === 0"
            [class.bg-gray-50]="i % 2 !== 0"
          >
            <td class="whitespace-nowrap p-3 text-sm font-medium text-gray-900">
              {{ log.attempted_at | date : 'dd-MM-yyyy h:mm a' }}
            </td>
            <td class="whitespace-nowrap p-3 text-sm text-gray-700">
              {{ log.scheduled_time }}
            </td>
            <td class="whitespace-nowrap p-3">
              <span [class]="statusClass(log.status)">{{ log.status }}</span>
            </td>
            <td class="whitespace-nowrap p-3 text-sm text-gray-700">
              {{ log.sessions_closed }}
            </td>
            <td
              class="max-w-xs truncate p-3 text-xs text-red-600"
              [title]="log.error_message ?? ''"
            >
              {{ log.error_message || '--' }}
            </td>
          </tr>
          } @empty {
          <tr class="bg-white">
            <td colspan="5">
              <shared-no-records-placeholder
                title="No auto-close logs found"
                [description]="
                  'No auto-close attempts recorded in the last ' +
                  selectedDays() +
                  ' days.'
                "
              />
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>
</div>
